import { render, staticRenderFns } from "./ModalWorkBook.vue?vue&type=template&id=64db6571&scoped=true&"
import script from "./ModalWorkBook.vue?vue&type=script&lang=js&"
export * from "./ModalWorkBook.vue?vue&type=script&lang=js&"
import style0 from "./ModalWorkBook.vue?vue&type=style&index=0&id=64db6571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db6571",
  null
  
)

export default component.exports